import React, { useState, useEffect } from 'react';
import { apiService } from "../constants/ApiService";
import Banner from "./About/Banner";
import Product from "./Product/Product";
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import Header from '../constants/layout/Header';
import './About/Carousel.css';
import ProductSlider from './Product/ProductSlider';
import TestimonialsSlider from './About/TestimonialsSlider';
import WhyUs from './About/WhyUs';
import BlogsSlider from './About/BlogsSlider';
import OurStory from './Auth/OurStory';
import { Helmet } from 'react-helmet';



const Home = ({ companyDetail }) => {

    const navigate = useNavigate();
    const [sliderTable, setSliderTable] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);

    const getSliderData = async (page = 1, limit = 10, search = "") => {
        try {
            let config = {
                headers: {
                    'Content-Type': 'application/json', // Important for file upload//s
                    'accept': 'application/json'
                }
            };

            const response = await apiService.get(`/api/SliderMaster/allslider?pageNo=${page}&limit=${limit}&searchKey=${search}`, config)
            if (response.response && response.response.data.errors) {
                console.log(response.response?.data?.errors)
            }

            if (response.status === true) {
                console.log(response)
                setSliderTable(response.slider_MasterData)
                // setTotalPage(response.totalPages)
                // console.log(response.message);
            }
            else {
                console.log(response.message);
            }
        } catch (error) {
            console.log(error)
            alert('SomeThing went wrong!!');
        }
    };

    const prevImage = () => {
        setCurrentIndex((prevIndex) => (prevIndex - 1 + sliderTable.length) % sliderTable.length);
    };

    const nextImage = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % sliderTable.length);
    };

    // Automatically change the image every 5 seconds
    useEffect(() => {
        const timeoutId = setTimeout(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % sliderTable.length);
        }, 5000);
        return () => clearTimeout(timeoutId);
    }, [currentIndex, sliderTable.length]);



    useEffect(() => {
        getSliderData();
    }, [!sliderTable]);

    return (
        <>
            <Helmet>
                <title>{companyDetail.comp_meta_title}</title>
                <meta name="description" content={`${companyDetail.comp_meta_desc} Powered by Shivkms`} />
                <meta name="keywords" content={`${companyDetail?.about_us_meta_keyword ? companyDetail.about_us_meta_keyword + ', ' : ''}Shivkms, Shiv Kirpa Multi Solution`} />
                <meta property="og:title" content={companyDetail.comp_meta_title} />
                <meta property="og:description" content={companyDetail.comp_meta_desc} />
                <meta property="og:image" content={`${window.location.origin}/assets/images/logo/Valorelle_Logo.png`} />
                <meta property="og:type" content="website" />
                <meta property="og:url" content={window.location.href} />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content={companyDetail.comp_meta_title} />
                <link rel="canonical" href={`${window.location.origin}`} />
            </Helmet>

            <section className="home-section pt-2">
                <div className="container-fluid-lg">
                    <Banner slider={sliderTable} />
                    <a
                        href="/ProductList"
                        className="btn btn-animation btn-sm home-button theme-bg-color text-light inter-font mt-3"
                    >
                        Find Your Signature Scent Now <i className='ms-2 fa fa-arrow-right' />
                    </a>
                    <ProductSlider />

                </div>
            </section>

            <OurStory companyDetail={companyDetail} />
            <WhyUs companyDetail={companyDetail} />
            <TestimonialsSlider />
            <section className="newsletter-section section-b-space">
                <div className="container-fluid-lg">
                    <div className="newsletter-box newsletter-box-2">
                        <div className="newsletter-contain py-5">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-xxl-4 col-lg-5 col-md-7 col-sm-9 offset-xxl-2 offset-md-1">
                                        <div className="newsletter-detail">
                                            <h2 className='text-dark'>Join the Valorelle Circle</h2>
                                            <p className='text-dark inter-font'>Be the first to know about new launches, exclusive offers, and scent stories you’ll love.</p>
                                            <h5 className='text-dark inter-font'>Get 10% off on your first order when you sign up</h5>
                                            <div className="input-box">
                                                <input
                                                    type="email"
                                                    className="form-control"
                                                    id="exampleFormControlInput1"
                                                    placeholder="Enter Your Email"
                                                />
                                                <i className="fa-solid fa-envelope arrow" />
                                                <button className="sub-btn  btn-animation">
                                                    <span className="d-sm-block d-none">Subscribe</span>
                                                    <i className="fa-solid fa-arrow-right icon" />
                                                </button>
                                            </div>

                                            <h5 className='text-dark mt-2 inter-font'>We never spam — just fragrance-filled inspiration.
                                            </h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <BlogsSlider />
        </>
    )
}

export default Home;